'use es6';

import UrlRegexFactory from './factories/UrlRegexFactory';
const URL_REGEX = UrlRegexFactory();
export default URL_REGEX;